import React from "react";

interface AboutMidContentProps {
  title: string;
  subTitle?: string;
  info?: React.ReactNode;
  text1?: React.ReactNode;
  text2?: React.ReactNode;
  image: string;
}

function AboutMidContent({ title, subTitle, info, text1, text2, image }: AboutMidContentProps) {
  return (
    <section className="about-inner-section">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Text column */}
          <div className="col-lg-6">
            <span className="page-section-label">{title}</span>
            {subTitle && <h2 className="inner-page-heading">{subTitle}</h2>}
            {info && (
              <p className="inner-page-text" style={{ marginBottom: "20px" }}>
                {info}
              </p>
            )}
            {text1 && <div className="inner-page-text">{text1}</div>}
            {text2 && <div className="inner-page-text" style={{ marginTop: "12px" }}>{text2}</div>}
          </div>

          {/* Image column */}
          <div className="col-lg-6">
            <img
              src={image}
              alt={subTitle || title}
              className="about-inner-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutMidContent;
